import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Button from 'Components/UI/Button';
import Modal from 'Components/UI/Modal';
import { TenantActions } from 'Store/Tenant/Tenant.actions';
import styles from './AvisoRemoverUsuario.module.scss';

interface IAvisoRemoverUsuario {
  visible?: boolean;
  userToDelete?: any;
  onClose: () => void;
  onConfirm?: () => void;
  isLoading: boolean;
}

const AvisoRemoverUsuario: FC<IAvisoRemoverUsuario> = ({
  visible,
  userToDelete,
  onClose,
  onConfirm,
  isLoading
}) => {
  const { t } = useTranslation('gerenciarUsuarios');
  const [isSendingData, setIsSendingData] = useState<boolean>(false);
  const dispatch = useDispatch();

  const removerConviteUsuario = (InvitedUserId: number) => {
    if (InvitedUserId) {
      dispatch(TenantActions.removeTenantInviteUser(InvitedUserId));
      setIsSendingData(true);
    }
  };

  const removerTenantUser = (userId: string) => {
    if (userId) {
      dispatch(TenantActions.removeTenantUser(userId));
      setIsSendingData(true);
    }
  };

  if (!isLoading && isSendingData) {
    onClose();
    setIsSendingData(false);
  }

  const buttons = (
    <div>
      {userToDelete?.InvitedUserId ? (
        <Button loading={isLoading} type={'link'} className={styles['link']} onClick={() => { removerConviteUsuario(userToDelete?.InvitedUserId); }}>
          {t('avisoRemover.confirmCancelInvite')}
        </Button>
      ) : (
        <Button loading={isLoading} className={styles['link']} onClick={() => { removerTenantUser(userToDelete?.Id); }}>
          {t('avisoRemover.confirmRemoveUser')}
        </Button>
      )}
      <Button className={styles['button']} type="primary" height={37} onClick={onClose}>
        {t('avisoRemover.cancel')}
      </Button>
    </div>
  );

  return (
    <Modal
      title={t('avisoRemover.modalTitle')}
      footerButtons={buttons}
      visible={visible}
      width={500}
      onCancel={onClose}
    >
      <div className={styles['descriptionWrapper']}>
        {userToDelete?.InvitedUserId ? (
          <>
            <div>{t('avisoRemover.cancelInviteDescription', { name: userToDelete?.Nome })}</div>
            <div>{t('avisoRemover.cancelInviteQuestion')}</div>
          </>
        ) : (
          <>
            <div>{t('avisoRemover.removeUserDescription', { name: userToDelete?.Nome })}</div>
            <div>{t('avisoRemover.removeUserQuestion')}</div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default AvisoRemoverUsuario;
